import { render, staticRenderFns } from "./PrimaryCta.vue?vue&type=template&id=11942352&scoped=true"
import script from "./PrimaryCta.vue?vue&type=script&lang=js"
export * from "./PrimaryCta.vue?vue&type=script&lang=js"
import style0 from "./PrimaryCta.vue?vue&type=style&index=0&id=11942352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11942352",
  null
  
)

export default component.exports